import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { usePageTitle } from '../hooks/usePageTitle.js';
import { analyticsEvents } from '../config/analyticsConfig.js';
import './CheckoutSuccess.css';

const CheckoutSuccess = () => {
  usePageTitle('Pagamento Confirmado');
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');

  useEffect(() => {
    // Rastrear checkout concluído
    analyticsEvents.completeCheckout('premium');
    
    // Redirecionar para o dashboard após 3 segundos
    const timer = setTimeout(() => {
      navigate('/dashboard');
    }, 3000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="checkout-success-container">
      <div className="success-card">
        <div className="success-icon">
          <svg width="80" height="80" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="10" fill="#10b981" />
            <path d="M8 12L11 15L16 9" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
        
        <h1>Assinatura Confirmada!</h1>
        <p>Seu pagamento foi processado com sucesso.</p>
        
        {sessionId && (
          <div className="session-info">
            <small>ID da Sessão: {sessionId}</small>
          </div>
        )}
        
        <p className="redirect-message">
          Você será redirecionado em alguns segundos...
        </p>
        
        <button onClick={() => navigate('/dashboard')} className="back-button-success">
          Ir para o Dashboard
        </button>
      </div>
    </div>
  );
};

export default CheckoutSuccess;
